/**
 * Which API workspaces the project switcher's "API Client › Workspaces" lists
 * (owner, 21.10.2026), pure:
 *
 *   All projects   every workspace
 *   No project     the workspaces no project holds
 *   a project      the project's own, in the project's order
 *   pending        none (like every other panel)
 *
 * Every list but a project's is sorted by name.
 */
import { ALL_PROJECTS, NO_PROJECT, normalizeScopeId } from './projectScopeFilter';
import { boundWorkspaces } from './projectBinding';
import { holdsWorkspace } from './projectBindingFields';

const byName = (a, b) => String(a?.name || '').localeCompare(String(b?.name || ''));

export function workspacesForScope({ scope = {}, projects = [], workspaces = [] } = {}) {
  const list = (workspaces || []).filter(Boolean);
  const id = normalizeScopeId(scope.activeProjectId);
  if (id === ALL_PROJECTS) return [...list].sort(byName);
  if (id === NO_PROJECT) {
    return list.filter((w) => !(projects || []).some((p) => holdsWorkspace(p, w.id))).sort(byName);
  }
  if (scope.status !== 'ready' || !scope.activeProject) return [];
  return boundWorkspaces(scope.activeProject, list);
}
